<!-- 添加 & 编辑部门 -->
<template>
    <!--添加界面-->
      <el-dialog class="model-depart-form" width="850px" :title="title" :visible="myVisible"  :destroy-on-close="true" @close="handerClose"
        :close-on-click-modal="false">
        <el-row :gutter="20"  style="margin-bottom: -10px;">
          <el-form  :model="ruleForm" :rules="rules" label-width="100px" label-position="left"  ref="ruleForm" >
            <el-col :span="12">
              <el-form-item label="部门名称" prop="deptname">
                  <el-input v-model="ruleForm.deptname" placeholder="请输入" clearable></el-input>
                </el-form-item>
            </el-col>  

            <el-col :span="12">
              <el-form-item label="部门管理员" prop="deptmanager">
                 <el-select v-model="ruleForm.deptmanager" placeholder="请选择" style="width: 100%" clearable>
                    <el-option :label="item.name" :value="item.id" v-for="item in allCompanyList" :key='item.id'></el-option>
                </el-select>
                  <!-- <SelectCommon  placeholder="请选择" style="width: 100%" :clearable="true" 
                                :defaultVal="ruleForm.deptmanager? ruleForm.deptmanager: undefined"
                                 apiPath="/tbCompany/getCompanyUser" 
                                 :keys="{label: 'name', value: 'id'}" 
                                 :params="{ companyId: $route.query.companyId }"
                                 @change="(value, datas) => handleSelectCommon(value, datas, 'deptmanager')" /> -->
                </el-form-item>
            </el-col>  
            
            <el-col :span="24">
              <el-form-item label="部门人员" prop="useridList">
                <div class="hd">
                  <el-input  v-model="searchText"  clearable placeholder="姓名 / 账号" style="width:200px; margin-right: 10px"  @keyup.enter.native="getComUser(1)"></el-input>
                  <el-button type="primary" size="medium" @click="getComUser(1)">查询</el-button>
                </div>
                <!--用户列表  @select="handerChkSelect" @selection-change="handerSectionChange"-->
                <el-table  :data="companyList" highlight-current-row   style="width: 100%;" 
                           
                            @selection-change="handerSectionChange"
                            @row-click="handerRowClick"
                            v-loading="listLoading"
                            :height="500"
                            ref="companyRef"   >
                  <el-table-column type="selection" width="50"></el-table-column>
                 
                  <el-table-column prop="phone" label="账号" width="140" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="name" label="姓名"  width="140" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="typeName" label="软件类型"  width="140" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="deptname" label="部门" min-width="160" show-overflow-tooltip>
                     <template slot-scope="scope">
                        <span>{{ scope.row.deptname || '-'}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                </el-form-item>
            </el-col>    
            
          </el-form>
        </el-row>
        

        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click.native="handerClose">取消</el-button>
          <el-button type="primary" @click.native="handerSubmit" :loading="confirmLoading">提交</el-button>
        </div>

      </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { API_Company,  API_User } from '@/api/index.js'
import  utils  from '@/utils/index'
import SelectCommon from '@/components/SelectCommon'
export default {
  props: {
    mode: {
      type: String,
      default: 'save'
    },

    visible: {
      type: Boolean,
      default: false
    },

    companymanageid: {
      type: String,
      default: ''
    },

    token: {
      type: String,
      default: ''
    },

    processDetail: {
      type: Object,
      default: () => null
    }
  },
  data () {
    // 校验部门名称是否唯一
    var validatorDept = async(rule, value, callback) => {
       if(!this.ruleForm.deptname) {
        callback("请输入部门名称")
      }else {
          if(this.oldDepartName != this.ruleForm.deptname ) {
            let res = await this.checkDepart(this.ruleForm.deptname);
            !res? callback('部门名称已存在'): callback();
          }
      }
    }

    return {
      myVisible: false,
      searchText: '',
      listLoading: false,
      confirmLoading: false,
      pageSize:10,
      pageNumber:1,
      total:0,
      
      checkCode:'',
      companyList: [],
      title: '',
      userId: '',

      selectedUserIdBack: [],

      rules: { 
          deptname: [
            // { required: true, message: '请输入部门名称', trigger: 'blur' },
            { required: true, validator: validatorDept, trigger: 'change' },
          ],

          deptmanager: [
            { required: false, message: '请选择部门管理员', trigger: 'change' }
          ],

          useridList: [
            // { required: true, validator: validateUser, trigger: 'change' }
            { required: false,  message: '请选择部门人员',  trigger: 'change' }
          ],
      },

      flag: '-1',
      allCompanyList: [],

      ruleForm: {
        deptname: '',     // 部门名称
        deptmanager: '',  // 部门管理员
        useridList: [],      // 部门人员
        companyid: this.companymanageid
      },

      oldDepartName: '', // 部门名称备份
    };
  },

  components: {
    SelectCommon
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    })
  },

  created() {
    this.userId = sessionStorage.getItem('dnnypt_id');
    this.myVisible = this.visible
  },

  async mounted() {
    // let { token, checkCode } = utils.getParamsByCookie();
    // this.token = token;
    // this.checkCode = checkCode;
    if(this.mode == 'save') {
      this.title = '新增部门'
      this.getComUser(0);
    }else {
      this.title = '编辑部门'
      let res = await this.getDetail();
      if(res) {
        this.getComUser(0);
      }
    }
  },

  methods: {
    // 校验公司名称是否唯一：true唯一 false 不唯一
    checkDepart(name) {
      return API_Company.checkDepartUnique({ deptname: name, companyid:  this.ruleForm.companyid }).then(res => {
        console.log('ressss--', res)
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(err => {
        return true;
      })
    },

    getDetail() {
      let param = {
          token: this.token,
          checkCode: this.checkCode,
          companyid: this.companymanageid,
          id: this.processDetail.id
      }
       this.listLoading = true;
       return API_Company.getDepartDetail(param).then((res) =>{
        if(res.data.code == 200){
          let data = res.data.data;
          let { deptname, deptmanager, userList = [], } = data;
          this.ruleForm.useridList = userList.map(item => ({id: item.id}))
          this.ruleForm.deptname = deptname
          this.ruleForm.deptmanager = deptmanager;
          this.oldDepartName = deptname
          // this.companyList = res.data.data;
          return true;
        }else {
           this.listLoading = false;
           if(res.data.code == 403){
                this.$router.push({path: 'loginAdmin'});
            }
           return false
        }
       
      }).catch(err =>{
        this.listLoading = false;
        this.$message.error('数据丢失，试试重新登录1！');
        return false;
      });
    },

    getComUser(flag){
      this.flag = flag;
      let param = {
          token: this.token,
          checkCode: this.checkCode,
          companyid: this.companymanageid,
          searchText: this.searchText,
      }
       this.listLoading = true;
       return API_Company.getCompanyUser(param).then((res) =>{
        if(res.data.code == 200){
          this.companyList = res.data.data;

          // 处理当表格模糊查询备份已勾选的数据
          if(!this.searchText) {
            // 删除搜索条件： 恢复数据备份
            this.allCompanyList = JSON.parse(JSON.stringify(this.companyList))
            this.ruleForm.useridList = [...this.ruleForm.useridList, ...JSON.parse(JSON.stringify(this.selectedUserIdBack))]
            // 去重
            this.ruleForm.useridList = this.uniqObj(this.ruleForm.useridList, 'id')
              // console.log("this.selectedUserIdBack2==", this.selectedUserIdBack, this.ruleForm.useridList)
          }else {
            // 条件过滤： 备份上次已选
            this.selectedUserIdBack = [...JSON.parse(JSON.stringify(this.ruleForm.useridList)), ...this.selectedUserIdBack]
            this.selectedUserIdBack = this.uniqObj(this.selectedUserIdBack, 'id')
            // console.log("this.selectedUserIdBack==", this.selectedUserIdBack)
          }
          this.listLoading = false;
          setTimeout(() => {
            // 初始化选中列表
            this.initSelectedUser();
          }, 100)
          return true;
        }else {
           this.listLoading = false;
           if(res.data.code == 403){
              this.$router.push({path: 'loginAdmin'});
            }
           return false
        }
       
      }).catch(err =>{
        this.listLoading = false;
        this.$message.error('数据丢失，试试重新登录1！');
        return false;
      });
    },

    // 数组对象去重(根据指定的数组元素)
    uniqObj(array,field) {
      let tempObj = {};
      array = array.reduce((cur, next) => {
        tempObj[next[field]] ? "" : tempObj[next[field]] = true && cur.push(next);
        return cur;
    },[])
      return array;
    },

    handleSelectCommon(value, datas, key) {
      this.ruleForm[key] = value[0]
      this.$refs.ruleForm.validateField(key);
    },

    handerSectionChange(data, column, event) {
       // 搜索状态不要清空数据(已选择数据情况下： this.ruleForm.useridList.length > 0)
       if(this.flag == 1 && this.ruleForm.useridList.length > 0) {
          this.flag = -1;
          return;
       }
       let selectedUserId = data.length > 0?
                             data.map(item => ({id: item.id})): []

      this.ruleForm.useridList = selectedUserId

      this.$refs.ruleForm.validateField('useridList');
    },
    
    // 单击行
    handerRowClick(row, column, event) {
      this.$set(row, 'selected', !row.selected)
      this.$refs.companyRef.toggleRowSelection(row);
    },
    
    // 单击复选框
    handerChkSelect(selection, row) {
      this.handerRowClick(row);
    },

    // 初始化选中列表
    initSelectedUser() {
      let selectedList = this.ruleForm.useridList;
      this.companyList.forEach( list => {
       selectedList.forEach(item => {
          if(list.id == item.id) {
            this.handerRowClick(list)
          }
        })
      })
    },

    handerSubmit(formName) {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          // 获取全部勾选的数据
          this.ruleForm.useridList = [...this.ruleForm.useridList, ...JSON.parse(JSON.stringify(this.selectedUserIdBack))]
          // 去重
          this.ruleForm.useridList = this.uniqObj(this.ruleForm.useridList, 'id')
          let useridList =  this.ruleForm.useridList.map( item => item.id)
          let data = { ...this.ruleForm }
          data.useridList = useridList.length > 0? useridList.join(): ''
          data.createUser = this.userId;
          this.confirmLoading = true;
          this.mode == 'save'? this.handerSave(data): this.handerUpdate(data)
        } 
      });
    },

    handerSave(data) {
       API_Company.addDept(data).then(res => {
          if(res.data.code == 200) {
            this.$message.success('新增成功');
            this.$emit('getList')
            this.handerClose();
          }else{
            if(res.data.code == 403){
                this.$router.push({path: 'loginAdmin'});
            }
          }
          this.confirmLoading = false;
        }).catch( err => {
          this.confirmLoading = false;
        })
    },

    handerUpdate(data) {
      data.id = this.processDetail.id
       API_Company.editDept(data).then(res => {
          if(res.data.code == 200) {
            this.$message.success('编辑成功');
            this.$emit('getList')
            this.handerClose();
          }else {
            if(res.data.code == 403){
                this.$router.push({path: 'loginAdmin'});
            }
          }
          this.confirmLoading = false;
        }).catch( err => {
          this.confirmLoading = false;
        })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    handerClose() {
      this.myVisible = false;
      this.$emit('update:visible', false)
    },
   
  }
}

</script>
<style lang='scss'>
.model-depart-form {
  .el-dialog__body {
    min-height: 30vh;
    padding: 20px 30px;
    padding-bottom: 15px;
  }
  .title {
    margin: 0;
    padding-left: 4px;
    font-size: 14px;
    color: #666;
    font-weight: normal;
  }
  .color-error {
    color: #eb6264;
    margin-right: 4px;
  }
  .hd {
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// ModalForm.vue?64ceb8bf